<style scoped>
.asset-photo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #f4f6f8;
  box-shadow: 0 4px 14px rgba(20, 30, 50, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.asset-photo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(20, 30, 50, 0.18);
}

.asset-photo-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-photo-card__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: #7367f0;
  font-size: 0.7rem;
  font-weight: 600;
}

.asset-photo-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0) 40%, rgba(15, 23, 42, 0.72) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-photo-card:hover .asset-photo-card__overlay {
  opacity: 1;
}

.asset-photo-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
}

.asset-photo-modal .modal-body {
  padding: 0;
}

.asset-photo-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.asset-photo-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 700;
}

.asset-photo-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: #f1f2f6;
  color: #4b5563;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-photo-modal__close:hover {
  background: #e94b4b;
  color: #fff;
}

.asset-photo-modal__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 1.5rem;
  background:
    linear-gradient(45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(-45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f4f5f7 75%),
    linear-gradient(-45deg, transparent 75%, #f4f5f7 75%);
  background-size: 22px 22px;
  background-position: 0 0, 0 11px, 11px -11px, -11px 0;
  background-color: #fafbfc;
}

.asset-photo-modal__img {
  max-width: 100%;
  max-height: 62vh;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);
}

.asset-photo-modal__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.5rem;
  text-align: center;
}

.asset-photo-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

@media (max-width: 575.98px) {
  .asset-photo-modal__stage {
    min-height: 220px;
    padding: 1rem;
  }
}

.required-label::after {
  content: ' *';
  color: red;
}
.field-error-text {
  color: #ea5455;
  font-size: 0.857rem;
  margin-top: 0.25rem;
}
.is-invalid-select {
  border: 1px solid #ea5455;
  border-radius: 4px;
}
</style>

<template>
  <div>
    <!-- Modal picture -->
    <b-modal
      id="modal-picture"
      v-model="pictureModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="asset-photo-modal"
    >
      <div class="asset-photo-modal__header">
        <div class="asset-photo-modal__title">
          <feather-icon
            icon="ImageIcon"
            size="16"
          />
          <span>Asset Photo</span>
        </div>
        <button
          type="button"
          class="asset-photo-modal__close"
          @click="pictureModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <div class="asset-photo-modal__stage">
        <img
          :src="`${ApiURL}upload/${asset.asset_photo}`"
          alt="Asset Photo"
          class="asset-photo-modal__img"
        >
      </div>

      <div class="asset-photo-modal__footer">
        <b-button
          :href="`${ApiURL}upload/${asset.asset_photo}`"
          target="_blank"
          variant="outline-primary"
          size="sm"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
            class="mr-50"
          />
          Download
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="pictureModal = false"
        >
          Close
        </b-button>
      </div>
    </b-modal>

    <b-row class="match-height">
      <b-col lg="12">
        <b-form
          v-if="asset"
          @submit.prevent="submitEditAsset"
        >
          <b-card
            no-body
            class="mb-0"
          >
            <b-row class="match-height">
              <b-col lg="12">
                <b-card title="Assets Detail">
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        type="button"
                        variant="primary"
                        class="mr-1"
                        @click="previous()"
                      >
                        <feather-icon
                          icon="ArrowLeftIcon"
                          size="16"
                          class="align-middle"
                        />
                        Back
                      </b-button>
                    </b-col>

                    <b-col
                      cols="6"
                      class="d-flex justify-content-end"
                    >
                      <div
                        v-if="asset.asset_photo"
                        class="asset-photo-card"
                        @click="showModal"
                      >
                        <img
                          :src="`${ApiURL}upload/${asset.asset_photo}`"
                          alt="Asset Photo"
                          class="asset-photo-card__img"
                        >
                        <div class="asset-photo-card__overlay">
                          <feather-icon
                            icon="ZoomInIcon"
                            size="16"
                          />
                          <span>Preview</span>
                        </div>
                      </div>
                    </b-col>

                    <b-col cols="12">
                      <div class="devider" />

                      <!-- Item ID — read only, no validation needed -->
                      <b-form-group
                        label="Item ID"
                        label-for="itemId"
                        label-cols-md="12"
                      >
                        <b-form-input
                          :value="asset.item ? asset.item.item_code : ''"
                          placeholder="Item ID"
                          readonly
                        />
                      </b-form-group>

                      <!-- Asset ID — read only -->
                      <b-form-group
                        label="Asset ID"
                        label-for="assetId"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_number"
                          placeholder="Asset ID"
                          readonly
                        />
                      </b-form-group>

                      <!-- Ref ID — optional -->
                      <b-form-group
                        label="Ref ID"
                        label-for="refId"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_ref_id"
                          placeholder="Ref ID"
                          :state="fieldState('asset_ref_id')"
                        />
                        <div
                          v-if="fieldError('asset_ref_id')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_ref_id') }}
                        </div>
                      </b-form-group>

                      <!-- Local ID — optional -->
                      <b-form-group
                        label="Local ID"
                        label-for="localId"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_local_id"
                          placeholder="Local ID"
                          :state="fieldState('asset_local_id')"
                        />
                        <div
                          v-if="fieldError('asset_local_id')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_local_id') }}
                        </div>
                      </b-form-group>

                      <!-- Asset Group — REQUIRED -->
                      <b-form-group
                        label-cols-md="12"
                        label-for="category"
                      >
                        <template #label>
                          <span class="required-label">Asset Group</span>
                        </template>
                        <v-select-new
                          v-model="asset.asset_category"
                          :options="categories"
                          :class="{ 'is-invalid-select': frontendErrors.asset_category || fieldError('asset_category') }"
                        />
                        <div
                          v-if="frontendErrors.asset_category || fieldError('asset_category')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_category || fieldError('asset_category') }}
                        </div>
                      </b-form-group>

                      <!-- Description — REQUIRED -->
                      <b-form-group
                        label-for="description"
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Description</span>
                        </template>
                        <b-form-input
                          v-model="asset.asset_description"
                          placeholder="Asset Description"
                          :state="frontendErrors.asset_description || fieldError('asset_description') ? false : null"
                        />
                        <div
                          v-if="frontendErrors.asset_description || fieldError('asset_description')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_description || fieldError('asset_description') }}
                        </div>
                      </b-form-group>

                      <!-- Note — optional -->
                      <b-form-group
                        label="Note"
                        label-for="note"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_note"
                          placeholder="Asset Note"
                          :state="fieldState('asset_note')"
                        />
                        <div
                          v-if="fieldError('asset_note')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_note') }}
                        </div>
                      </b-form-group>

                      <!-- GPS — optional -->
                      <b-form-group
                        label="GPS"
                        label-for="gps"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_gps"
                          placeholder="Asset GPS"
                          :state="fieldState('asset_gps')"
                        />
                        <div
                          v-if="fieldError('asset_gps')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_gps') }}
                        </div>
                      </b-form-group>

                      <!-- Date of Acquisition — REQUIRED -->
                      <b-form-group
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Date of Acquisition</span>
                        </template>
                        <b-form-datepicker
                          v-model="asset.asset_date_of_acquistion"
                          placeholder="Asset Date of Acquisition"
                          :state="frontendErrors.asset_date_of_acquistion || fieldError('asset_date_of_acquistion') ? false : null"
                        />
                        <div
                          v-if="frontendErrors.asset_date_of_acquistion || fieldError('asset_date_of_acquistion')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_date_of_acquistion || fieldError('asset_date_of_acquistion') }}
                        </div>
                      </b-form-group>

                      <!-- Acquisition Value — REQUIRED -->
                      <b-form-group
                        label-for="assetAcquisitionValue"
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Acquisition Value</span>
                        </template>
                        <b-form-input
                          v-model="asset.asset_acquistion_value"
                          placeholder="Asset Acquisition Value"
                          type="number"
                          :state="frontendErrors.asset_acquistion_value || fieldError('asset_acquistion_value') ? false : null"
                        />
                        <div
                          v-if="frontendErrors.asset_acquistion_value || fieldError('asset_acquistion_value')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_acquistion_value || fieldError('asset_acquistion_value') }}
                        </div>
                      </b-form-group>

                      <!-- Depreciation Method — REQUIRED -->
                      <b-form-group
                        label-for="assetDepreciationMethod"
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Depreciation Method</span>
                        </template>
                        <v-select-new
                          v-model="asset.asset_depreciation_method"
                          :options="methods"
                          :class="{ 'is-invalid-select': frontendErrors.asset_depreciation_method || fieldError('asset_depreciation_method') }"
                        />
                        <div
                          v-if="frontendErrors.asset_depreciation_method || fieldError('asset_depreciation_method')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_depreciation_method || fieldError('asset_depreciation_method') }}
                        </div>
                      </b-form-group>

                      <!-- Residual Value — optional -->
                      <b-form-group
                        label="Residual Value"
                        label-for="assetResidualValue"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_residual_value"
                          placeholder="Asset Residual Value"
                          type="number"
                          :state="fieldState('asset_residual_value')"
                        />
                        <div
                          v-if="fieldError('asset_residual_value')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_residual_value') }}
                        </div>
                      </b-form-group>

                      <!-- Market Value — optional -->
                      <b-form-group
                        label="Market Value"
                        label-for="assetMarketValue"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_market_value"
                          placeholder="Asset Market Value"
                          type="number"
                          :state="fieldState('asset_market_value')"
                        />
                        <div
                          v-if="fieldError('asset_market_value')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_market_value') }}
                        </div>
                      </b-form-group>

                      <!-- Asset Condition — REQUIRED -->
                      <b-form-group
                        label-for="assetCondition"
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Asset Condition</span>
                        </template>
                        <v-select-new
                          v-model="asset.asset_condition"
                          :options="conditions"
                          :class="{ 'is-invalid-select': frontendErrors.asset_condition || fieldError('asset_condition') }"
                        />
                        <div
                          v-if="frontendErrors.asset_condition || fieldError('asset_condition')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_condition || fieldError('asset_condition') }}
                        </div>
                      </b-form-group>

                      <!-- Asset Address — optional in backend but shown -->
                      <b-form-group
                        label="Asset Address"
                        label-for="assetAddress"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_address"
                          placeholder="Asset Address"
                          :state="fieldState('asset_address')"
                        />
                        <div
                          v-if="fieldError('asset_address')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_address') }}
                        </div>
                      </b-form-group>

                      <!-- Asset Responsible — REQUIRED -->
                      <b-form-group
                        label-for="assetResponsible"
                        label-cols-md="12"
                      >
                        <template #label>
                          <span class="required-label">Asset Responsible</span>
                        </template>
                        <b-form-input
                          v-model="asset.asset_responsible"
                          placeholder="Asset Responsible"
                          :state="frontendErrors.asset_responsible || fieldError('asset_responsible') ? false : null"
                        />
                        <div
                          v-if="frontendErrors.asset_responsible || fieldError('asset_responsible')"
                          class="field-error-text"
                        >
                          {{ frontendErrors.asset_responsible || fieldError('asset_responsible') }}
                        </div>
                      </b-form-group>

                      <!-- Serial Number — optional -->
                      <b-form-group
                        label="Serial Number"
                        label-for="assetSerialNumber"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_serial_no"
                          placeholder="Asset Serial Number"
                          :state="fieldState('asset_serial_no')"
                        />
                        <div
                          v-if="fieldError('asset_serial_no')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_serial_no') }}
                        </div>
                      </b-form-group>

                      <!-- Warranty — optional -->
                      <b-form-group
                        label="Warranty"
                        label-for="assetWarranty"
                        label-cols-md="12"
                      >
                        <b-form-input
                          v-model="asset.asset_warranty"
                          placeholder="Asset Warranty"
                          :state="fieldState('asset_warranty')"
                        />
                        <div
                          v-if="fieldError('asset_warranty')"
                          class="field-error-text"
                        >
                          {{ fieldError('asset_warranty') }}
                        </div>
                      </b-form-group>

                      <!-- Photo — optional -->
                      <b-form-group
                        label="Photo"
                        label-for="assetPhoto"
                        label-cols-md="12"
                      >
                        <b-form-file
                          ref="uploadFilePhoto"
                          accept="image/*"
                          placeholder="Choose a photo or drop it here."
                          drop-placeholder="Drop a photo here..."
                          @change="handleFilesUploadPhoto"
                        />
                        <div
                          v-if="photoPreviewUrl"
                          class="mt-1"
                        >
                          <small class="text-muted">New photo preview:</small><br>
                          <div class="asset-photo-card mt-50">
                            <img
                              :src="photoPreviewUrl"
                              alt="New photo preview"
                              class="asset-photo-card__img"
                            >
                          </div>
                        </div>
                      </b-form-group>

                    </b-col>
                  </b-row>

                  <!-- Summary of all backend field errors -->
                  <b-alert
                    v-if="hasBackendErrors"
                    variant="danger"
                    show
                    class="mb-1"
                  >
                    <div class="alert-body">
                      <strong>Please fix the following errors:</strong>
                      <ul class="mb-0 mt-50">
                        <li
                          v-for="(err, key) in backendErrors"
                          :key="key"
                        >
                          {{ err.message }}
                        </li>
                      </ul>
                    </div>
                  </b-alert>

                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="submitButtonDisabled"
                  >
                    {{ submitButtonDisabled ? 'Submitting...' : 'Submit' }}
                  </b-button>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-form>

        <b-card v-else>
          <p class="text-center text-muted my-2">
            Loading asset detail...
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard,
  BListGroup, BListGroupItem, BFormDatepicker, BFormFile, BAlert,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import apiEndpoints from '@/constants/apiEndpoints'

// Required fields as per backend validation
const REQUIRED_FIELDS = [
  { key: 'asset_category', label: 'Asset Group' },
  { key: 'asset_description', label: 'Description' },
  { key: 'asset_date_of_acquistion', label: 'Date of Acquisition' },
  { key: 'asset_acquistion_value', label: 'Acquisition Value' },
  { key: 'asset_depreciation_method',label: 'Depreciation Method' },
  { key: 'asset_condition', label: 'Asset Condition' },
  { key: 'asset_responsible', label: 'Asset Responsible' },
]

export default {
  components: {
    BFormDatepicker,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormFile,
    BAlert,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      asset: null,
      photoFile: null,
      photoPreviewUrl: null,
      submitButtonDisabled: false,
      pictureModal: false,
      ApiURL: process.env.VUE_APP_API_URL,

      // Frontend validation errors (before submit)
      frontendErrors: {},

      // Backend field-level errors from response.data.data
      backendErrors: {},

      categories: [
        'Machinery (MC)', 'Furniture & Fixture', 'Office Equipment',
        'Lab Equipment', 'Vehicle (VH)', 'Building', 'Software',
        'Low Value Asset', 'Land','Field Equipment',
      ],
      methods: [
        'Metode Garis Lurus', 'Metode Saldo Menurun', 'Metode Unit Produksi',
        'Metode Jam Kerja', 'Metode Penyusutan Akselerasi',
      ],
      conditions: ['Baik', 'Sedang', 'Buruk'],
    }
  },

  computed: {
    hasBackendErrors() {
      return Object.keys(this.backendErrors).length > 0
    },
  },

  mounted() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      const itemDetail = JSON.parse(localStorage.getItem('assetDetail'))
      this.asset = itemDetail
    },

    showModal() {
      this.pictureModal = true
    },

    handleFilesUploadPhoto(e) {
      const files = e.target.files || e.dataTransfer.files
      if (files && files.length > 0) {
        const file = files[0]
        this.photoFile = file
        this.photoPreviewUrl = URL.createObjectURL(files[0])
      } else {
        this.photoFile = null
        this.photoPreviewUrl = null
      }
    },

    // Returns the backend error message for a field, or null
    fieldError(key) {
      return this.backendErrors[key] ? this.backendErrors[key].message : null
    },

    // Returns Bootstrap state (false = invalid, null = neutral) for optional fields
    // that may still receive backend errors
    fieldState(key) {
      return this.backendErrors[key] ? false : null
    },

    // Frontend validation — mirrors backend required fields
    validateForm() {
      const errors = {}
      REQUIRED_FIELDS.forEach(({ key, label }) => {
        const val = this.asset[key]
        if (val === null || val === undefined || String(val).trim() === '') {
          errors[key] = `${label} is required.`
        }
      })
      this.frontendErrors = errors
      return Object.keys(errors).length === 0
    },

    submitEditAsset() {
      // Clear previous errors
      this.backendErrors = {}
      this.frontendErrors = {}

      // Run frontend validation first
      if (!this.validateForm()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please fill in all required fields.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      this.submitButtonDisabled = true

      const userToken = this.$cookies.get('userToken')
      const headers = { Authorization: `Bearer ${userToken}` }

      const formData = new FormData()
      formData.append('asset_id', this.asset.asset_id)
      formData.append('asset_number', this.asset.asset_number)
      formData.append('asset_ref_id', this.asset.asset_ref_id || '')
      formData.append('asset_local_id', this.asset.asset_local_id || '')
      formData.append('asset_category', this.asset.asset_category || '')
      formData.append('asset_description', this.asset.asset_description || '')
      formData.append('asset_gps', this.asset.asset_gps || '')
      formData.append('asset_date_of_acquistion', this.asset.asset_date_of_acquistion || '')
      formData.append('asset_acquistion_value', this.asset.asset_acquistion_value || 0)
      formData.append('asset_depreciation_method',this.asset.asset_depreciation_method || '')
      formData.append('asset_residual_value', this.asset.asset_residual_value || 0)
      formData.append('asset_market_value', this.asset.asset_market_value || 0)
      formData.append('asset_condition', this.asset.asset_condition || '')
      formData.append('asset_address', this.asset.asset_address || '')
      formData.append('asset_responsible', this.asset.asset_responsible || '')
      formData.append('asset_serial_no', this.asset.asset_serial_no || '')
      formData.append('asset_note', this.asset.asset_note || '')
      formData.append('asset_warranty', this.asset.asset_warranty || '')
      formData.append('asset_status', this.asset.asset_status || 'active')
      formData.append('time', moment().toISOString())

      if (this.photoFile) {
        formData.append('photo', this.photoFile, this.photoFile.name)
      }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_EDIT_ASSET}`,
          formData,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Edit Asset Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-procurement-assets-list' })
          } else {
            this.submitButtonDisabled = false

            // Parse backend field-level errors
            // Shape: { asset_date_of_acquistion: { message: '...', rule: 'required' }, ... }
            const errorData = response.data.data
            if (errorData && typeof errorData === 'object') {
              this.backendErrors = errorData
            }

            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || 'Edit Asset Failed',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(err => {
          this.submitButtonDisabled = false

          // axios puts 4xx/5xx responses in err.response
          const res = err.response && err.response.data
          if (res && res.data && typeof res.data === 'object') {
            this.backendErrors = res.data
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: (res && res.message) || 'Edit Asset Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    previous() {
      this.$router.push({ name: 'apps-procurement-assets-list' })
    },

    dateFormat(value, format = 'MM/DD/YYYY') {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
  },
}
</script>